import { useMutation, useQuery } from 'react-query';
import { network } from 'services/network';

const getPrivilegesList = () => {
    return network
        .get('admin/bo/privilegeList')
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const createRole = (params) => {
    return network
        .post('admin/bo/roleCreate', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const updateRole = (params) => {
    return network
        .post(`admin/bo/roleUpdateByID/${params.id}`, params.role)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const deleteRole = (params: string) => {
    const url = `admin/bo/roleDelete/${params}`;
    return network
        .post(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryPrivilegesList = () => {
    return useQuery('getPrivilegesList', () => getPrivilegesList());
};

export const useMutationDeleteRole = () => {
    return useMutation<any, QueryError, string>((params) => deleteRole(params));
};

export const useMutationCreateRole = () => {
    return useMutation<any, QueryError, IRoleNew>((params) => createRole(params));
};

export const useMutationUpdateRole = () => {
    return useMutation<any, QueryError, { role: IRoleNew; id: string }>((params) => updateRole(params));
};
